var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var _a, _b, _c, _d, _e, _f;
import { Subject } from '@/models/Subject';
import { isEqual } from 'lodash';
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
let SubjectSelect = class SubjectSelect extends Vue {
    constructor() {
        // File structure for Typescript files in your Vue project
        // https://tutorials.atabix.com/frontend/typscript_file_structure/
        super(...arguments);
        // #endregion
        // #region @Refs
        // #endregion
        // #region Class properties
        this.areas = [];
        this.topics = [];
        this.isLoading = true;
        // #endregion
    }
    get selectedArea() {
        return this.area || null;
    }
    set selectedArea(area) {
        if (isEqual(area && area.id, this.area && this.area.id)) {
            return;
        }
        this.$emit('update:area', area && new Subject(area));
    }
    get selectedTopic() {
        return this.topic || null;
    }
    set selectedTopic(topic) {
        if (isEqual(topic && topic.id, this.topic && this.topic.id)) {
            return;
        }
        this.$emit('update:topic', topic && new Subject(topic));
    }
    // #endregion
    async created() {
        this.areas = await this.fetchAreas();
        if (this.area) {
            this.selectedArea = this.area;
            if (this.topic) {
                this.selectedTopic = this.topic;
            }
        }
    }
    // #region Lifecycle & Init
    mounted() {
        this.isLoading = false;
        if (this.area) {
            const area = this.area;
            const children = area.children;
            if (children) {
                children.map((child) => {
                    this.topics.push(child);
                });
            }
        }
    }
    // #endregion
    // #region Class methods
    findAreaTopics(area) {
        const foundArea = this.areas.find((a) => a.id === (area && area.id));
        return (foundArea && foundArea.children) || [];
    }
    // #endregion
    // #region Async methods
    async fetchAreas() {
        return new Subject()
            .include('children')
            .all()
            .catch(() => []);
    }
    // #endregion
    // #region Getters
    get topicsKey() {
        return (this.selectedArea && this.selectedArea.id) || 'asdasish';
    }
    // #endregion
    // #region Watchers
    onAreaChanged(area, oldArea) {
        if ((oldArea && oldArea.id) !== (this.area && this.area.id)) {
            // console.log('SubjectSelect.ts - onAreaChanged', area);
            this.topics = this.findAreaTopics(area);
            this.selectedArea = area;
        }
    }
    onTopicChanged(topic, oldTopic) {
        if ((oldTopic && oldTopic.id) !== (this.topic && this.topic.id)) {
            // console.log('SubjectSelect.ts - onTopicChanged', topic);
            this.topic = topic;
        }
    }
};
__decorate([
    Prop(),
    __metadata("design:type", typeof (_a = typeof Subject !== "undefined" && Subject) === "function" ? _a : Object)
], SubjectSelect.prototype, "area", void 0);
__decorate([
    Prop(),
    __metadata("design:type", typeof (_b = typeof Subject !== "undefined" && Subject) === "function" ? _b : Object)
], SubjectSelect.prototype, "topic", void 0);
__decorate([
    Prop(),
    __metadata("design:type", Boolean)
], SubjectSelect.prototype, "disabled", void 0);
__decorate([
    Watch('area', { deep: true }),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [typeof (_c = typeof Subject !== "undefined" && Subject) === "function" ? _c : Object, typeof (_d = typeof Subject !== "undefined" && Subject) === "function" ? _d : Object]),
    __metadata("design:returntype", void 0)
], SubjectSelect.prototype, "onAreaChanged", null);
__decorate([
    Watch('topic', { deep: true }),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [typeof (_e = typeof Subject !== "undefined" && Subject) === "function" ? _e : Object, typeof (_f = typeof Subject !== "undefined" && Subject) === "function" ? _f : Object]),
    __metadata("design:returntype", void 0)
], SubjectSelect.prototype, "onTopicChanged", null);
SubjectSelect = __decorate([
    Component({
        components: {
        //
        },
    })
], SubjectSelect);
export default SubjectSelect;
